import { render, staticRenderFns } from "./ReplyBox.vue?vue&type=template&id=3d328abb&scoped=true&"
import script from "./ReplyBox.vue?vue&type=script&lang=js&"
export * from "./ReplyBox.vue?vue&type=script&lang=js&"
import style0 from "./ReplyBox.vue?vue&type=style&index=0&id=3d328abb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d328abb",
  null
  
)

export default component.exports